<!-- SVG definitions is manually copied from node_modules/dkdws/src/img/all-svg-icons.svg -->
<div class="hidden">
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <svg xmlns="http://www.w3.org/2000/svg">
    <symbol id="add" viewBox="0 0 24 24">
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
      />
    </symbol>
    <symbol id="alert-outline" viewBox="0 0 24 24">
      <path fill="currentColor" d="M12 2L1 21h22M12 6l7.53 13H4.47M11 10v4h2v-4m-2 6v2h2v-2" />
    </symbol>
    <symbol id="angle-arrow-down-white" viewBox="0 0 24 24">
      <path fill="#fff" d="M7.41 8.58L12 13.17l4.59-4.59L18 10l-6 6-6-6 1.41-1.42z" />
    </symbol>
    <symbol id="angle-arrow-down" viewBox="0 0 24 24">
      <path d="M7.41 8.58L12 13.17l4.59-4.59L18 10l-6 6-6-6 1.41-1.42z" />
    </symbol>
    <symbol id="angle-arrow-up" viewBox="0 0 24 24">
      <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z" />
    </symbol>
    <symbol id="arrow-left" viewBox="0 0 24 24">
      <path d="M20 11v2H8l5.5 5.5-1.42 1.42L4.16 12l7.92-7.92L13.5 5.5 8 11h12z" />
    </symbol>
    <symbol id="arrow-right" viewBox="0 0 24 24">
      <path d="M4 11v2h12l-5.5 5.5 1.42 1.42L19.84 12l-7.92-7.92L10.5 5.5 16 11H4z" />
    </symbol>
    <symbol id="book-open" viewBox="0 0 24 24">
      <path
        d="M13 12h7v1.5h-7m0-4h7V11h-7m0 3.5h7V16h-7m8-12H3a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m0 15h-9V6h9"
      />
    </symbol>
    <symbol id="calendar" viewBox="0 0 24 24">
      <path
        d="M19 19H5V8h14m-3-7v2H8V1H6v2H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-1V1m-1 11h-5v5h5v-5z"
      />
    </symbol>
    <symbol id="cash-multiple" viewBox="0 0 24 24">
      <path
        d="M5 6h18v12H5V6m9 3a3 3 0 0 1 3 3 3 3 0 0 1-3 3 3 3 0 0 1-3-3 3 3 0 0 1 3-3M9 8a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2v-4a2 2 0 0 1-2-2H9m-8 2h2v10h16v2H1V10z"
      />
    </symbol>
    <symbol id="check-box-checked" viewBox="0 0 24 24">
      <g fill="none" fill-rule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="#1A1A1A"
          d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm12.293 4.293l-6.921 6.921-3.665-3.664-1.414 1.414 5.079 5.079 8.335-8.336-1.414-1.414z"
        />
      </g>
    </symbol>
    <symbol id="check-box-disabled" viewBox="0 0 24 24">
      <g fill="none" fill-rule="evenodd">
        <path d="M0 0h24v24H0z" />
        <rect
          width="16"
          height="16"
          x="4"
          y="4"
          fill="#F5F5F5"
          stroke="#BFBFBF"
          stroke-width="2"
          rx="2"
        />
      </g>
    </symbol>
    <symbol id="check-box-focus" viewBox="0 0 24 24">
      <g fill="none" fill-rule="evenodd">
        <path fill="#FEBB30" d="M0 0h24v24H0V0z" />
        <rect
          width="16"
          height="16"
          x="4"
          y="4"
          fill="#FFF"
          stroke="#1A1A1A"
          stroke-width="2"
          rx="2"
        />
      </g>
    </symbol>
    <symbol id="check-box-unchecked" viewBox="0 0 24 24">
      <g fill="none" fill-rule="evenodd">
        <path d="M0 0h24v24H0z" />
        <rect
          width="16"
          height="16"
          x="4"
          y="4"
          fill="#FFF"
          stroke="#1A1A1A"
          stroke-width="2"
          rx="2"
        />
      </g>
    </symbol>
    <symbol id="check-circle-outline" viewBox="0 0 24 24">
      <path
        d="M12 2a10 10 0 0 1 10 10 10 10 0 0 1-10 10A10 10 0 0 1 2 12 10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8 8 8 0 0 0 8 8 8 8 0 0 0 8-8 8 8 0 0 0-8-8m-1 12.5L6.5 12l1.41-1.41L11 13.67l5.59-5.58L18 9.5l-7 7z"
      />
    </symbol>
    <symbol id="check" viewBox="0 0 24 24">
      <path d="M21 7L9 19l-5.5-5.5 1.41-1.41L9 16.17 19.59 5.59 21 7z" />
    </symbol>
    <symbol id="checkbox-blank-outline" viewBox="0 0 24 24">
      <path
        d="M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5h14z"
      />
    </symbol>
    <symbol id="checkbox-marked" viewBox="0 0 24 24">
      <path
        d="M10 17l-5-5 1.41-1.42L10 14.17l7.59-7.59L19 8m0-5H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z"
      />
    </symbol>
    <symbol id="chevron-left" viewBox="0 0 24 24">
      <path d="M15.41 16.58L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.42z" />
    </symbol>
    <symbol id="chevron-right" viewBox="0 0 24 24">
      <path d="M8.59 16.58L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.42z" />
    </symbol>
    <symbol id="close-circle-outline" viewBox="0 0 24 24">
      <path
        d="M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-18C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m2.59 6L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8z"
      />
    </symbol>
    <symbol id="close-circle" viewBox="0 0 24 24">
      <g fill="none" fill-rule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="#FFF"
          d="M13.414 12l2.314-2.314-1.414-1.414L12 10.586 9.686 8.272 8.272 9.686 10.586 12l-2.31 2.31 1.413 1.415L12 13.415l2.31 2.31 1.415-1.414L13.415 12zM12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14z"
        />
      </g>
    </symbol>
    <symbol id="close" viewBox="0 0 24 24">
      <path
        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
      />
    </symbol>
    <symbol id="content-save" viewBox="0 0 24 24">
      <path
        d="M15 9H5V5h10m-3 14a3 3 0 0 1-3-3 3 3 0 0 1 3-3 3 3 0 0 1 3 3 3 3 0 0 1-3 3m5-16H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7l-4-4z"
      />
    </symbol>
    <symbol id="delete-outline" viewBox="0 0 24 24">
      <path
        d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z"
      />
      <path fill="none" d="M0 0h24v24H0V0z" />
    </symbol>
    <symbol id="delete" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M19 4h-3.5l-1-1h-5l-1 1H5v2h14M6 19a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H6v12z"
      />
    </symbol>
    <symbol id="dots-vertical" viewBox="0 0 24 24">
      <path
        d="M12 16a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2 2 2 0 0 1 2-2m0-6a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2 2 2 0 0 1 2-2m0-6a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2 2 2 0 0 1 2-2z"
      />
    </symbol>
    <symbol id="download" viewBox="0 0 24 24">
      <path
        d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
      />
      <path fill="none" d="M0 0h24v24H0z" />
    </symbol>
    <symbol id="downloadicon" viewBox="0 0 24 24">
      <path stroke="black" stroke-width="10" d="M12 1 12 15" />
      <path stroke="black" stroke-width="3" d="M1 22 23 22" />
      <polygon points="1 12 23 12 12 19" style="fill: black" />
    </symbol>
    <symbol id="error" viewBox="0 0 24 24">
      <path
        d="M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-18C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m2.59 6L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8z"
      />
    </symbol>
    <symbol id="error-filled" viewBox="0 0 24 24">
      <path
        d="M 20.488281 3.511719 C 15.808594 -1.171875 8.191406 -1.171875 3.511719 3.511719 C -1.171875 8.191406 -1.171875 15.808594 3.511719 20.488281 C 8.191406 25.171875 15.808594 25.171875 20.488281 20.488281 C 25.171875 15.808594 25.171875 8.191406 20.488281 3.511719 Z M 16.734375 16.734375 C 16.375 17.09375 15.789062 17.09375 15.429688 16.734375 L 12 13.304688 L 8.410156 16.898438 C 8.046875 17.257812 7.464844 17.257812 7.101562 16.898438 C 6.742188 16.535156 6.742188 15.953125 7.101562 15.589844 L 10.695312 12 L 7.265625 8.570312 C 6.90625 8.210938 6.90625 7.625 7.265625 7.265625 C 7.625 6.90625 8.210938 6.90625 8.570312 7.265625 L 12 10.695312 L 15.265625 7.429688 C 15.625 7.070312 16.210938 7.070312 16.570312 7.429688 C 16.929688 7.789062 16.929688 8.375 16.570312 8.734375 L 13.304688 12 L 16.734375 15.429688 C 17.09375 15.789062 17.09375 16.375 16.734375 16.734375 Z M 16.734375 16.734375 "
      />
    </symbol>
    <symbol id="file-document-box" viewBox="0 0 24 24">
      <path
        d="M5 3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2H5m0 2h14v14H5V5m2 2v2h10V7H7m0 4v2h10v-2H7m0 4v2h7v-2H7z"
      />
    </symbol>
    <symbol id="file" viewBox="0 0 24 24">
      <path fill="none" d="M0 0h24v24H0V0z" />
      <g>
        <path
          d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z"
        />
      </g>
    </symbol>
    <symbol id="folder-multiple" viewBox="0 0 24 24">
      <path
        d="M22 4a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h6l2 2h8M2 6v14h18v2H2a2 2 0 0 1-2-2V6h2m4 0v10h16V6H6z"
      />
    </symbol>
    <symbol id="help-circle-outline" viewBox="0 0 24 24">
      <path
        d="M11 18h2v-2h-2v2m1-16A10 10 0 0 0 2 12a10 10 0 0 0 10 10 10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-14a4 4 0 0 0-4 4h2a2 2 0 0 1 2-2 2 2 0 0 1 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5a4 4 0 0 0-4-4z"
      />
    </symbol>
    <symbol id="info" viewBox="0 0 24 24">
      <path fill="none" d="M0 0h24v24H0V0z" />
      <path d="M11 7h2v2h-2zM11 11h2v6h-2z" />
      <path
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
      />
    </symbol>
    <symbol id="language" viewBox="0 0 24 24">
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95a15.65 15.65 0 0 0-1.38-3.56A8.03 8.03 0 0 1 18.92 8zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56A7.987 7.987 0 0 1 5.08 16zm2.95-8H5.08a7.987 7.987 0 0 1 4.33-3.56A15.65 15.65 0 0 0 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95a8.03 8.03 0 0 1-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
      />
    </symbol>
    <symbol id="magnify" viewBox="0 0 24 24">
      <path
        d="M9.5 3A6.5 6.5 0 0 1 16 9.5c0 1.61-.59 3.09-1.56 4.23l.27.27h.79l5 5-1.5 1.5-5-5v-.79l-.27-.27A6.516 6.516 0 0 1 9.5 16 6.5 6.5 0 0 1 3 9.5 6.5 6.5 0 0 1 9.5 3m0 2C7 5 5 7 5 9.5S7 14 9.5 14 14 12 14 9.5 12 5 9.5 5z"
      />
    </symbol>
    <symbol id="menu-down" viewBox="0 0 24 24"><path d="M7 10l5 5 5-5H7z" /></symbol>
    <symbol id="menu-left" viewBox="0 0 24 24"><path d="M14 7l-5 5 5 5V7z" /></symbol>
    <symbol id="menu-right" viewBox="0 0 24 24"><path d="M10 17l5-5-5-5v10z" /></symbol>
    <symbol id="menu-up" viewBox="0 0 24 24"><path d="M7 15l5-5 5 5H7z" /></symbol>
    <symbol id="message" viewBox="0 0 24 24">
      <path
        d="M20 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h16M4 4v13.17L5.17 16H20V4H4m2 3h12v2H6V7m0 4h9v2H6v-2z"
      />
    </symbol>
    <symbol id="minus" viewBox="0 0 24 24"><path d="M19 13H5v-2h14v2z" /></symbol>
    <symbol id="open-in-new" viewBox="0 0 24 24">
      <path
        d="M14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3m-2 16H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7h-2v7z"
      />
    </symbol>
    <symbol id="pencil" viewBox="0 0 24 24">
      <path
        d="M20.71 7.04c.39-.39.39-1.04 0-1.41l-2.34-2.34c-.37-.39-1.02-.39-1.41 0l-1.84 1.83 3.75 3.75M3 17.25V21h3.75L17.81 9.93l-3.75-3.75L3 17.25z"
      />
    </symbol>
    <symbol id="plus" viewBox="0 0 24 24"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" /></symbol>
    <symbol id="printer" viewBox="0 0 24 24">
      <path
        d="M18 3H6v4h12m1 5a1 1 0 0 1-1-1 1 1 0 0 1 1-1 1 1 0 0 1 1 1 1 1 0 0 1-1 1m-3 7H8v-5h8m3-6H5a3 3 0 0 0-3 3v6h4v4h12v-4h4v-6a3 3 0 0 0-3-3z"
      />
    </symbol>
    <symbol id="radio-disabled" viewBox="0 0 24 24">
      <g fill="none" fill-rule="evenodd">
        <path d="M0 0h24v24H0z" />
        <circle cx="12" cy="12" r="8" fill="#F5F5F5" stroke="#BFBFBF" stroke-width="2" />
      </g>
    </symbol>
    <symbol id="radio-focused" viewBox="0 0 24 24">
      <g fill="none" fill-rule="evenodd">
        <path d="M0 0h24v24H0z" />
        <circle
          cx="12"
          cy="12"
          r="8"
          fill="#FFF"
          stroke="#1A1A1A"
          stroke-linejoin="square"
          stroke-width="2"
        />
        <circle cx="12" cy="12" r="10.5" stroke="#FEBB30" stroke-width="3" />
      </g>
    </symbol>
    <symbol id="radio-marked" viewBox="0 0 24 24">
      <g fill="none" fill-rule="evenodd">
        <path d="M0 0h24v24H0z" />
        <g stroke-linejoin="square">
          <circle cx="12" cy="12" r="6.5" fill="#1A1A1A" stroke="#FFF" stroke-width="5" />
          <circle cx="12" cy="12" r="8" stroke="#1A1A1A" stroke-width="2" />
        </g>
      </g>
    </symbol>
    <symbol id="radio-unmarked" viewBox="0 0 24 24">
      <g fill="none" fill-rule="evenodd">
        <path d="M0 0h24v24H0z" />
        <circle cx="12" cy="12" r="8" fill="#FFF" stroke="#1A1A1A" stroke-width="2" />
      </g>
    </symbol>
    <symbol id="refresh" viewBox="0 0 24 24">
      <path
        d="M17.65 6.35A7.958 7.958 0 0 0 12 4a8 8 0 0 0-8 8 8 8 0 0 0 8 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0 1 12 18a6 6 0 0 1-6-6 6 6 0 0 1 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
      />
    </symbol>
    <symbol id="save" viewBox="0 0 24 24">
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        d="M17 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"
      />
    </symbol>
    <symbol id="settings" viewBox="0 0 24 24">
      <path
        d="M19.43 12.97l2.11 1.66c.19.15.24.42.12.64l-2 3.46c-.12.22-.39.3-.61.22l-2.49-1.01c-.52.4-1.06.73-1.69.99l-.37 2.65c-.04.24-.25.42-.5.42h-4c-.25 0-.46-.18-.5-.42l-.37-2.65c-.63-.25-1.17-.59-1.69-.99l-2.49 1.01c-.22.08-.49 0-.61-.22l-2-3.46a.493.493 0 0 1 .12-.64l2.11-1.66L4.5 12l.07-1-2.11-1.63a.493.493 0 0 1-.12-.64l2-3.46c.12-.22.39-.31.61-.22l2.49 1c.52-.39 1.06-.73 1.69-.98l.37-2.65c.04-.24.25-.42.5-.42h4c.25 0 .46.18.5.42l.37 2.65c.63.25 1.17.59 1.69.98l2.49-1c.22-.09.49 0 .61.22l2 3.46c.12.22.07.49-.12.64L19.43 11l.07 1-.07.97M6.5 12c0 .58.09 1.13.25 1.66l-2.07 1.7.75 1.3 2.52-.94c.74.81 1.73 1.4 2.85 1.65l.44 2.63h1.5l.44-2.63c1.12-.24 2.12-.83 2.87-1.64l2.51.94.75-1.3-2.07-1.7c.17-.53.26-1.09.26-1.67 0-.57-.09-1.13-.25-1.65l2.06-1.69-.75-1.3-2.5.93a5.526 5.526 0 0 0-2.87-1.66L12.75 4h-1.5l-.44 2.63c-1.12.25-2.12.84-2.87 1.66l-2.5-.94-.75 1.3 2.06 1.7c-.16.52-.25 1.08-.25 1.65M12 8.5a3.5 3.5 0 0 1 3.5 3.5 3.5 3.5 0 0 1-3.5 3.5A3.5 3.5 0 0 1 8.5 12 3.5 3.5 0 0 1 12 8.5m0 2a1.5 1.5 0 0 0-1.5 1.5 1.5 1.5 0 0 0 1.5 1.5 1.5 1.5 0 0 0 1.5-1.5 1.5 1.5 0 0 0-1.5-1.5z"
      />
    </symbol>
    <symbol id="sort-acending" viewBox="0 0 24 24">
      <g fill="none" fill-rule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path fill="#1A1A1A" d="M6 13l6 6 6-6z" />
        <path stroke="#1A1A1A" d="M16.793 10.5L12 5.707 7.207 10.5h9.586z" />
      </g>
    </symbol>
    <symbol id="sort-descending" viewBox="0 0 24 24">
      <g fill="none" fill-rule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path stroke="#1A1A1A" d="M7.207 13.5L12 18.293l4.793-4.793H7.207z" />
        <path fill="#1A1A1A" d="M18 11l-6-6-6 6z" />
      </g>
    </symbol>
    <symbol id="sort-none" viewBox="0 0 24 24">
      <g fill="none" fill-rule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          d="M7.207 13.5L12 18.293l4.793-4.793H7.207zm9.586-3L12 5.707 7.207 10.5h9.586z"
          stroke="#1A1A1A"
        />
      </g>
    </symbol>
    <symbol id="success" viewBox="0 0 24 24">
      <path
        d="M12 2a10 10 0 0 1 10 10 10 10 0 0 1-10 10A10 10 0 0 1 2 12 10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8 8 8 0 0 0 8 8 8 8 0 0 0 8-8 8 8 0 0 0-8-8m-1 12.5L6.5 12l1.41-1.41L11 13.67l5.59-5.58L18 9.5l-7 7z"
      />
    </symbol>
    <symbol id="unpublished" viewBox="0 0 24 24">
      <path
        d="M 20.476562 23.300781 L 17.523438 20.351562 C 16.726562 20.882812 15.863281 21.292969 14.9375 21.574219 C 14.011719 21.859375 13.035156 22 12 22 C 10.617188 22 9.316406 21.738281 8.101562 21.210938 C 6.882812 20.6875 5.824219 19.976562 4.925781 19.074219 C 4.023438 18.175781 3.3125 17.117188 2.789062 15.898438 C 2.261719 14.683594 2 13.382812 2 12 C 2 10.964844 2.140625 9.988281 2.425781 9.0625 C 2.707031 8.136719 3.117188 7.273438 3.648438 6.476562 L 0.675781 3.5 L 2.101562 2.074219 L 21.898438 21.875 Z M 12 20 C 12.75 20 13.460938 19.898438 14.136719 19.699219 C 14.8125 19.5 15.449219 19.226562 16.050781 18.875 L 12.175781 15 L 10.601562 16.601562 L 6.351562 12.351562 L 7.75 10.949219 L 10.601562 13.800781 L 10.773438 13.601562 L 5.125 7.949219 C 4.773438 8.550781 4.5 9.1875 4.300781 9.863281 C 4.101562 10.539062 4 11.25 4 12 C 4 14.214844 4.777344 16.105469 6.335938 17.664062 C 7.894531 19.222656 9.785156 20 12 20 Z M 20.375 17.5 L 18.898438 16.023438 C 19.25 15.441406 19.519531 14.8125 19.710938 14.136719 C 19.902344 13.460938 20 12.75 20 12 C 20 9.785156 19.222656 7.894531 17.664062 6.335938 C 16.105469 4.777344 14.214844 4 12 4 C 11.25 4 10.539062 4.097656 9.863281 4.289062 C 9.1875 4.480469 8.558594 4.75 7.976562 5.101562 L 6.5 3.625 C 7.300781 3.109375 8.164062 2.707031 9.085938 2.425781 C 10.011719 2.140625 10.984375 2 12 2 C 13.382812 2 14.683594 2.261719 15.898438 2.789062 C 17.117188 3.3125 18.175781 4.023438 19.074219 4.925781 C 19.976562 5.824219 20.6875 6.882812 21.210938 8.101562 C 21.738281 9.316406 22 10.617188 22 12 C 22 13.015625 21.859375 13.988281 21.574219 14.914062 C 21.292969 15.835938 20.890625 16.699219 20.375 17.5 Z M 15.050781 12.148438 L 13.648438 10.75 L 16.25 8.148438 L 17.648438 9.550781 Z M 13.449219 10.550781 Z M 10.601562 13.398438 Z M 10.601562 13.398438 "
      />
    </symbol>
    <symbol id="warning" viewBox="0 0 24 24">
      <path d="M12 2L1 21h22M12 6l7.53 13H4.47M11 10v4h2v-4m-2 6v2h2v-2" />
    </symbol>
    <symbol id="warning-filled" viewBox="0 0 24 24">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
    </symbol>
    <symbol id="no-warning" viewBox="0 0 24 24">
      <path
        d="M 22 0 H 2 c -1.11 0 -2 0.89 -2 2 v 20 a 2 2 0 0 0 2 2 h 20 a 2 2 0 0 0 2 -2 V 2 a 2 2 0 0 0 -2 -2 H 2 h 14 z
        M 21 7 L 9 19 l -5.5 -5.5 l 1.41 -1.41 L 9 16.17 L 19.59 5.59 L 21 7 z"
      />
    </symbol>
    <symbol id="content-copy" viewBox="0 -960 960 960">
      <path
        d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z"
      />
    </symbol>
    <symbol id="lock" viewBox="0 -960 960 960">
      <path
        d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm0-80h480v-400H240v400Zm240-120q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80ZM240-160v-400 400Z"
      />
    </symbol>
  </svg>
</div>
